import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AppContext = createContext(null);

export function AppProvider({ children }) {
  const [colours, setColours] = useState([]);
  const [config, setConfig] = useState({ vehicle_price: 13990, deposit: 200, terms: null });
  const [colourSlug, setColourSlugState] = useState(() => {
    const fromQuery = new URLSearchParams(window.location.search).get("colore");
    return fromQuery || localStorage.getItem("swapa_colore") || null;
  });

  useEffect(() => {
    api.get("/colours").then((r) => setColours(r.data)).catch(() => {});
    api.get("/config").then((r) => setConfig(r.data)).catch(() => {});
  }, []);

  const setColour = useCallback((slug) => {
    setColourSlugState(slug);
    if (slug) localStorage.setItem("swapa_colore", slug);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "select_colour", colour: slug });
  }, []);

  const selectedColour = colours.find((c) => c.slug === colourSlug) || null;

  return (
    <AppContext.Provider value={{ colours, config, colourSlug, setColour, selectedColour }}>
      {children}
    </AppContext.Provider>
  );
}

export const useApp = () => useContext(AppContext);

export const STOCK_LABELS = {
  available: { text: "Prêt-à-Drive — In stock", tone: "text-emerald-400 border-emerald-400/30" },
  low: { text: "Disponibilità limitata", tone: "text-swapa-yellow border-swapa-yellow/40" },
  incoming: { text: "Coming soon", tone: "text-zinc-400 border-zinc-500/40" },
  unavailable: { text: "Non disponibile", tone: "text-zinc-500 border-zinc-600/40" },
};
